import "trix";
import "@rails/actiontext";

import Rails from '@rails/ujs';

import "../stylesheets/application";
import "materialize-css/dist/js/materialize";

import { startPhoneNumberAutoFormatter } from "./phone-number-auto-format";

Rails.start();

window.Materialize = M;

$.ajaxSetup({
  headers: { "X-CSRF-Token": $.rails.csrfToken() },
  contentType: "application/json",
  dataType: "json"
});

const disableTrixEditorFileAttachment = () => {
  document.addEventListener("trix-file-accept", (event) => {
    event.preventDefault();
  });
};

const isComponentInitialized = (componentName) =>
  window.REGISTER_BC.initializedComponents[componentName] === true;

const componentInitialized = (componentName) =>
  window.REGISTER_BC.initializedComponents[componentName] = true;

const showToast = (message, options = {}) => {
  const classes = options.classes || "";
  const duration = options.duration || 2000;
  const showOnReload = options.showOnReload || false;

  if (!message) {
    return;
  }

  if (showOnReload) {
    registerToastToShowOnPageLoad(message, {
      classes: classes,
      duration: duration,
    });
  } else {
    Materialize.toast({
      html: message,
      classes: classes,
      displayLength: duration,
    });
  }
};

const registerToastToShowOnPageLoad = (message, options = {}) => {
  try {
    localStorage.setItem("toast", JSON.stringify({
      message,
      options,
    }));
  } catch (error) {
    Rollbar.error(error.message)
  }
};

const showOnPageLoadToast = () => {
  try {
    const toast = JSON.parse(localStorage.getItem("toast"));
    if (!toast) {
      return;
    }

    showToast(toast.message, toast.options);
  } catch (error) {
    Rollbar.error(error.message)
  } finally {
    localStorage.removeItem("toast");
  }
};

const debounce = (func) => {
  let timer;
  return (event) => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(func, 100, event);
  };
}

const showSuccessToast = (message = "Update successfull", showOnReload = false) => showToast(
  message,
  { classes: "green darken-3", showOnReload }
);

const showErrorToast = (message = "An error occured", showOnReload = false) => showToast(
  message,
  { classes: "red darken-3", showOnReload },
);

const addAJAXResponseHandlers = (element, options = {}) => {
  const $element = $(element);

  const shouldShowErrorToast = options.noErrorToast ? false : true;
  const shouldShowSuccessToast = options.noSuccessToast ? false : true;

  const onError = (event, message) => {
    if (shouldShowErrorToast) {
      showErrorToast(message || options.errorMessage);
    }

    if (options.onError && typeof options.onError === "function") {
      options.onError(event);
    }
  }

  const onSuccess = (event) => {
    const response = event.detail[0];

    if (response.error) {
      onError(event, response.message);
      return;
    }

    if (shouldShowSuccessToast) {
      showSuccessToast(options.successMessage || response.message);
    }

    if (options.onSuccess && typeof options.onSuccess === "function") {
      options.onSuccess(response, event);
    }
  };

  const selector = options.selector || null;

  $element.on("ajax:error", selector, onError);
  $element.on("ajax:success", selector, onSuccess);
};

const updateRequiredIcon = (inputElement) => {
  const $inputElement = $(inputElement);

  const $inputField = $inputElement.closest(".js-input-field");
  if (!$inputField.length) {
    return;
  }

  const $requiredIconElement = $inputField.find(".js-student-profile-required");
  if (!$requiredIconElement) {
    return;
  }

  if ($inputElement.val()) {
    $requiredIconElement.addClass("hide");
  } else {
    $requiredIconElement.removeClass("hide");
  }
};

const getEnrollmentStatus = (enrollmentId) => {
  let $statusBadge = $(`.js-status-badge[data-enrollment-id="${enrollmentId}"]`);
  if ($statusBadge.length === 0) {
    return null;
  }

  return $statusBadge.get(0).textContent.toLowerCase().replace(" ", "_");
};

const updateEnrollmentStatusBadge = (newStatus, enrollmentId) => {
  if (!newStatus) {
    return;
  }

  let $statusBadges = $(".js-status-badge");

  if (enrollmentId) {
    $statusBadges = $statusBadges.filter(
      (index, element) => $(element).data("enrollmentId") == enrollmentId
    )
  }

  $statusBadges.each((index, element) => element.innerText = newStatus);
};

const fixBrokeninputElements = () => {
  $(`input[type="number"],input[type="text"],input[type="email"],input[type="tel"]`).each((index, input) => {
    const $input = $(input);
    if ($input.val()) {
      $(`label[for="${$input.attr("id")}"]`).addClass("active");
    }
  });
};

const initCitizenshipMetadataSelects = () => {
  const $citizenshipStatusSelects = $(".js-citizenship-status select");

  $citizenshipStatusSelects.on("change", (event) => {
    const citizenshipStatus = event.target.value;

    const $countryOfcitizenshipfield = $(event.target)
      .closest(".js-citizenship-metadata")
      .find(".js-counrty-of-citizenship");

    if (citizenshipStatus === "permanent_resident") {
      $countryOfcitizenshipfield.removeClass("hide");
    } else {
      $countryOfcitizenshipfield.addClass("hide");
    }
  });
};

const initStatusUpdateSelect = () => {
  const $statusUpdateSelects = $(".js-status-update-select");

  $statusUpdateSelects.on("change", (event) => {
    const status = event.target.value;
    const enrollmentId = $(event.target).data("enrollmentId");

    if (status === "declined") {
      const $rejectModal = $(`.js-reject-modal[data-enrollment-id="${enrollmentId}"]`);
      Materialize.Modal.getInstance($rejectModal.get(0)).open();
      return;
    }

    const request = $.ajax({
      type: "PUT",
      url: `/enrollments/${enrollmentId}`,
      data: JSON.stringify({
        id: enrollmentId,
        status: status,
      })
    });

    request.done(({ status }) => {
      $(".js-declined-reason").closest(".collapsible").addClass("hide");

      updateEnrollmentStatusBadge(status, enrollmentId);
      showSuccessToast();
    });

    request.fail(() => showErrorToast());
  });
};

const initRejectModal = () => {
  const $rejectModal = $(`.js-reject-modal`);
  const $rejectForm = $rejectModal.find(".js-reject-form");
  const $rejectReasonInput = $rejectForm.find("textarea");
  const $closeRejectModalButton = $rejectForm.find(".js-modal-close");
  const $statusUpdateSelect = $rejectModal.siblings(".js-status-update-select");
  const enrollmentId = $statusUpdateSelect.data("enrollmentId");

  const $rejectReason = $(".js-declined-reason")
  const $rejectReasonSection = $rejectReason.closest(".collapsible");

  $closeRejectModalButton.on("click", () => {
    $rejectReasonInput.val("");

    const enrollmentStatus = getEnrollmentStatus();

    if (!enrollmentStatus) {
      return;
    }

    $statusUpdateSelect.val(enrollmentStatus);
    Materialize.FormSelect.getInstance($statusUpdateSelect.get(0))._setValueToInput();
  });

  const ajaxHandlerOptions = {
    onSuccess: (response) => {
      updateEnrollmentStatusBadge(response.status, enrollmentId);

      $rejectModal.each((index, modalElement) => {
        Materialize.Modal.getInstance(modalElement).close();
      });

      $rejectReason.text($rejectReasonInput.val());
      $rejectReasonSection.removeClass("hide");

      $rejectReasonInput.val("");
    },
  };

  addAJAXResponseHandlers($rejectForm, ajaxHandlerOptions);
};

const initAutoFormatPhoneNumber = () => {
  startPhoneNumberAutoFormatter(".js-phone-number-with-formating");
};

const initSidenav = (selector = ".js-sidenav") => {
  $(selector).sidenav();

  const onWindowResize = () => {
    const $body = $("body");
    const $sideNav = $(".js-sidenav");

    if (!$body.hasClass("is-admin-section") || $sideNav.length === 0) {
      return;
    }

    const isDesktop = $(window).width() >= 993;
    if (isDesktop) {
      $sideNav.addClass("sidenav-fixed");
      $body.addClass("has-fixed-sidenav");
    } else {
      $sideNav.removeClass("sidenav-fixed");
      $body.removeClass("has-fixed-sidenav");
    }
  }

  $(window).on("resize", debounce(onWindowResize));
  onWindowResize();
};

const initDatePickers = (selector = ".datepicker") => {
  const elements = document.querySelectorAll(selector);

  if (elements) {
    const currentYear = new Date().getFullYear();
    Materialize.Datepicker.init(elements, {
      format: "yyyy-mm-dd",
      setDefaultDate: true,
      yearRange: [currentYear - 100, currentYear + 10],
    });
  }
};

const initTimePickers = (selector = ".timepicker") => {
  const elements = document.querySelectorAll(selector);

  if (elements) {
    Materialize.Timepicker.init(elements);
  }
};

const initTabs = (selector = ".js-tabs") => {
  const tabs = document.querySelectorAll(selector);
  const $tabs = $(selector);

  if ($tabs.length) {
    Materialize.Tabs.init(tabs, {
      onShow: (element) => {
        if (history && typeof history.pushState === "function") {
          const url = new URL(window.location.href);
          url.searchParams.set("tab", element.id);
          history.pushState({}, "", url);
        }
       },
    });

    const url = new URL(window.location.href);
    const activeTab = url.searchParams.get("tab");

    if (activeTab) {
      $tabs.each((index, element) => {
        Materialize.Tabs.getInstance(element).select(activeTab);
      });
    }
  }
};

const initCollapsibles = (selector = ".collapsible") => {
  const elements = document.querySelectorAll(selector);

  if (elements) {
    Materialize.Collapsible.init(elements, {
      onOpenStart: (element) => {
        const expandLessElement = element.querySelector(".js-collapsible-expand-less");
        const expandMoreElement = element.querySelector(".js-collapsible-expand-more");

        if (!expandLessElement || !expandMoreElement) {
          return;
        }

        expandLessElement.classList.remove("hide");
        expandMoreElement.classList.add("hide");

        const event = document.createEvent("HTMLEvents");
        event.initEvent("collapsible:open", true, true);
        event.eventName = "collapsible:open";
        element.dispatchEvent(event);
      },
      onCloseStart: (element) => {
        const expandLessElement = element.querySelector(".js-collapsible-expand-less");
        const expandMoreElement = element.querySelector(".js-collapsible-expand-more");

        if (!expandLessElement || !expandMoreElement) {
          return;
        }

        expandLessElement.classList.add("hide");
        expandMoreElement.classList.remove("hide");

        const event = document.createEvent("HTMLEvents");
        event.initEvent("collapsible:close", true, true);
        event.eventName = "collapsible:close";
        element.dispatchEvent(event);
      }
    });
  }
};

const initDropdowns = (selector = ".dropdown-trigger") => {
  const elements = document.querySelectorAll(selector);

  if (elements) {
    Materialize.Dropdown.init(elements);
  }
}

const initModals = (selector = ".js-modal", options = {}) => {
  const modalElements = document.querySelectorAll(selector);

  if (!modalElements) {
    return;
  }

  modalElements.forEach((modalElement) => {
    modalElement.querySelectorAll(".modal-close").forEach((modalCloseElement) => {
      modalCloseElement.addEventListener("click", (event) => {
        if (modalCloseElement.tagName.toLowerCase() === "a") {
          event.preventDefault();
        }
      });
    });
  });

  Materialize.Modal.init(modalElements, options);
};

const initNonDismissableModals = (selector = ".js-non-dismissible-modal") => initModals(selector, { dismissible: false });

const initSelectBoxes = () => {
  const elements = document.querySelectorAll("select");

  if (elements) {
    Materialize.FormSelect.init(elements);
  }
};

const initTooltips = (selector = ".tooltipped") => {
  const elements = document.querySelectorAll(selector);

  if (elements) {
    Materialize.Tooltip.init(elements);
  }
};

const initExportToCsvLinks = () => {
  const $csvExortLink = $(".js-export-to-csv");

  $csvExortLink.each((index, element) => {
    addAJAXResponseHandlers(element, {
      successMessage: "The CSV is being generated. It will be emailed to you when done.",
    });
  });
};

const initStudentSignupForm = () => {
  const $accountTypeSelect = $(".js-student-sign-up-account-type")

  if (!$accountTypeSelect.length) {
    return;
  }

  const $form = $accountTypeSelect.closest("form");
  const $studentAccountTypeDescription = $(".js-student-account-type-description");
  const $guardianAccountTypeDescription = $(".js-guardian-account-type-description");
  const $dateOfBirthInput = $(".js-date-picker");
  const $dateOfBirthInputField = $dateOfBirthInput.closest(".js-input-field");
  const $studentKindInput = $(".js-student-kind");
  const $studentKindInputField = $studentKindInput.closest(".js-input-field");
  const $guardianKindInput = $(".js-guardian-kind");

  $guardianKindInput.detach();

  $accountTypeSelect.on("change", (event) => {
    if (event.currentTarget.value === "Guardian") {
      // This is the Guardian account type
      $studentAccountTypeDescription.addClass("hide");
      $guardianAccountTypeDescription.removeClass("hide");

      $dateOfBirthInputField.addClass("hide");
      $studentKindInputField.addClass("hide");

      $dateOfBirthInput.detach();
      $studentKindInput.detach();

      $form.append($guardianKindInput);
    } else {
      // This is the Student account type
      $guardianAccountTypeDescription.addClass("hide");
      $studentAccountTypeDescription.removeClass("hide");

      $dateOfBirthInputField.append($dateOfBirthInput);
      $studentKindInputField.append($studentKindInput);

      $dateOfBirthInputField.removeClass("hide");
      $studentKindInputField.removeClass("hide");
    }
  });
};

const initNotifications = () => {
  const notificationLinks = document.querySelectorAll(".js-notification-link");

  notificationLinks.forEach((notificationLink) => {
    notificationLink.addEventListener("ajax:success", (event) => {
      const { notification } = event.detail[0];

      if (notification && notification.params && notification.params.url) {
        window.location.assign(notification.params.url);
        return;
      }

      const closedNotificationElement = document.querySelector(`.js-notification[data-id="${notification.id}"]`);
      if (closedNotificationElement) {
        closedNotificationElement.classList.add("hide");

        const notificationElements = document.querySelectorAll(".js-notification:not(.hide)");
        if (notificationElements.length === 0) {
          document.querySelector(".js-notificaton-empty-state").classList.remove("hide");
        }
      }
    });
  });
};

const initEditStudentProfilePage = () => {
  const editStudentProfileForm = document.querySelector(".js-edit-student-profile-form");
  const $studentKindSelect = $(".js-student-kind");

  const getDocumentInputNames = (requiredOnly = false, includeAll = false) => {
    const studentKind = $studentKindSelect.val();
    let documentInputNames = [];

    if (studentKind === "graduated_student" || includeAll) {
      documentInputNames = documentInputNames.concat([
        "student[proof_of_residency][]",
        "student[proof_of_citizenship]",
        "student[learning_plan]",
      ]).concat(requiredOnly ? [] : ["student[high_school_transcript]"])
    } else if (studentKind === "non_graduated_adult" || includeAll) {
      documentInputNames = documentInputNames.concat([
        "student[proof_of_residency][]",
        "student[proof_of_citizenship]",
      ]).concat(requiredOnly ? [] : ["student[high_school_transcript]", "student[graduation_plan]"])
    } else if (studentKind === "non_graduated_student" || includeAll) {
      documentInputNames = documentInputNames.concat([
        "student[proof_of_age]",
        "student[proof_of_guardianship_of_child][]",
        "student[proof_of_residency][]",
        "student[proof_of_citizenship]",
      ]).concat(requiredOnly ? [] : ["student[high_school_transcript]", "student[graduation_plan]"])
    } else if (studentKind === "langley_school_district_student" || includeAll) {
      documentInputNames = documentInputNames.concat([
        "student[cross_enrollment_permission_form]",
        "student[legal_identification]",
        "student[photo_identification]",
      ]).concat(requiredOnly ? [] : ["student[high_school_transcript]"])
    } else if (studentKind === "out_of_district_student" || includeAll) {
      documentInputNames = documentInputNames.concat([
        "student[proof_of_residency][]",
        "student[guardian_proof_of_citizenship]",
        "student[proof_of_guardianship_of_child][]",
        "student[cross_enrollment_permission_form]",
        "student[legal_identification]",
        "student[photo_identification]",
      ]).concat(requiredOnly ? [] : ["student[high_school_transcript]"])
    } else if (studentKind === "out_of_district" || studentKind === "out_of_district_langley_resident" || includeAll) {
      documentInputNames = documentInputNames.concat([
        "student[proof_of_age]",
        "student[proof_of_residency][]",
        "student[proof_of_guardianship_of_child][]",
        "student[guardian_proof_of_citizenship]",
      ]).concat(requiredOnly ? [] : [
        "student[medical_alert_information_form]",
        "student[individual_education_plan]",
        "student[aboriginal_ancestry]",
        "student[custody_orders]",
        "student[court_order]",
      ]);
    }

    return documentInputNames;
  };

  const getRequiredInputNames = () => {
    const studentKind = $studentKindSelect.val();

    let requiredInputNames = [
      "student[email]",
      "student[first_name]",
      "student[legal_first_name]",
      "student[last_name]",
      "student[legal_last_name]",
      "student[gender]",
      "student[date_of_birth]",
      "student[birthplace]",
      "student[spoken_language]",
      "student[health_condition]",
      "student[aboriginal_status]",
      "student[primary_phone_number]",
      "student[emergency_contact_phone_number]",
      "student[emergency_contact_first_name]",
      "student[emergency_contact_last_name]",
      "student[emergency_contact_relationship]",
      "student[address_street]",
      "student[address_postal_code]",
      "student[address_city]",
      "student[grade]",
      "student[kind]",
      "student[guardian_1_first_name]",
      "student[guardian_1_last_name]",
      "student[guardian_1_relationship]",
      "student[guardian_1_email]",
      "student[guardian_1_phone_number]",
      "student[guardian_1_work_phone_number]",
      "student[guardian_1_address_city]",
      "student[guardian_1_address_street]",
      "student[guardian_1_address_postal_code]",
      "student[diagnoses]",
      "student[personal_health_number]",
    ];

    if (studentKind === "out_of_district" || studentKind === "out_of_district_langley_resident") {
      requiredInputNames = requiredInputNames.concat([
        "student[home_school]",
        "student[previous_school]",
      ]);
    }

    return requiredInputNames.concat(getDocumentInputNames(true));
  };

  const updateDocumentInputVisibility = () => {
    const documentInputNames = getDocumentInputNames();

    editStudentProfileForm.querySelectorAll(".js-document-input-field").forEach((documentInputField) => {
      documentInputField.classList.add("hide");
    });

    documentInputNames.forEach((documentInputName) => {
      const $documentInput = $(editStudentProfileForm).find(`[name='${documentInputName}']`);
      $documentInput.closest(".js-document-input-field").removeClass("hide");
    });
  }

  const onRequiredInputUpdated = (inputElement) => {
    updateRequiredIcon(inputElement);
  };

  const initPaymentModal = () => {
    $(document).on("change", ".js-payment-method select", (event) => {
      const $paymentMethodSelect = $(event.target);

      const $paymentForm = $paymentMethodSelect.closest(".js-add-payment-form");
      const $paymentLastDigitsContainer = $paymentForm.find(".js-payment-digits");
      const $paymentLastDigitsInput = $paymentLastDigitsContainer.find("input");

      if ($paymentMethodSelect.val() == "cash" || $paymentMethodSelect.val() == "cheque" || $paymentMethodSelect.val() == "eCheque - SCO") {
        $paymentLastDigitsContainer.addClass("hide");
        $paymentLastDigitsInput.attr("required", false);
        $paymentLastDigitsInput.val("");
      } else {
        $paymentLastDigitsContainer.removeClass("hide");
        $paymentLastDigitsInput.attr("required", true);
      }
    });


    $(document).on("click", ".js-add-payment-modal .js-modal-close", (event) => {
      const $paymentForm = $(event.target).closest(".js-add-payment-form");
      const $contentInput = $paymentForm.find("textarea");
      const $numberInput = $paymentForm.find("[type=\"number\"]");
      const $paymentAmountInput = $paymentForm.find(".js-amount-field")
      const $paymentLast4Input = $paymentForm.find(".js-last-4-field")

      $numberInput.val("");
      $contentInput.val("");
      $paymentAmountInput.val("");
      $paymentLast4Input.val("");
    });
  };

  const initChoicesCheckbox = () => {
    $(document).on("change", ".js-choices-checkbox", (event) => {
      const $futureChoicesCheckbox = $(".js-future-choices-checkbox")

      if ($futureChoicesCheckbox.prop("checked") === false) {
        return;
      }

      $futureChoicesCheckbox.prop("checked", !event.target.checked);
    });

    $(document).on("change", ".js-future-choices-checkbox", (event) => {
      const $choicesCheckbox = $(".js-choices-checkbox")

      if ($choicesCheckbox.prop("checked") === false) {
        return;
      }

      $choicesCheckbox.prop("checked", !event.target.checked);
    });
  };

  const init = () => {
    getRequiredInputNames().forEach((requiredInputName) => {
      const $input = $(editStudentProfileForm).find(`[name='${requiredInputName}']`);

      if ($input.length == 0) {
        return;
      }

      if ($input.prop("tagName").toLowerCase() === "select") {
        $input.on("change", () => onRequiredInputUpdated($input.get(0)));
      } else if ($input.hasClass("js-date-picker") || $input.hasClass("file-path")) {
        // TODO: Should use the datepicker events.
        // TODO: Figure out a better way to check for the file-path input
        setInterval(() => onRequiredInputUpdated($input.get(0)), 500);
      } else {
        $input.on("keyup", () => onRequiredInputUpdated($input.get(0)));
      }
    });

    getDocumentInputNames(true, true).forEach((documentInputName) => {
      const $documentInput = $(editStudentProfileForm).find(`[name='${documentInputName}']`);
      $documentInput.on("change", () => onRequiredInputUpdated($documentInput.get(0)));
    });

    updateDocumentInputVisibility();
  };

  init();
  initPaymentModal();
  initChoicesCheckbox();
};

const initDocumentInputFields = () => {
  const documentFields = document.querySelectorAll(".js-document-input-field");

  documentFields.forEach((documentField) => {
    const $documentField = $(documentField);
    const $documentExpiry = $documentField.find(".js-expiry");
    const $editDocumentExpiry = $documentField.find(".js-edit-expiry");
    const $documentExpiryField = $documentField.find(".js-expiry-field");
    const $inputFieldContainer = $documentField.find(".js-document-input-container");
    const $documentFileInput = $documentField.find("input[type=\"file\"]")
    const $documentUploadedContainer = $documentField.find(".js-document-uploaded-container");

    const $clearButton = $documentField.find(".js-clear-file-input");

    const $unsavedHint = $documentField.find(".js-unsaved-hint");

    $documentFileInput.on("change", () => {
      updateRequiredIcon($documentFileInput);

      if ($documentFileInput[0].files.length > 0) {
        $clearButton.removeClass("hide");
        $unsavedHint.removeClass("hide");
      }

      if ($documentFileInput.prop("multiple") && $documentFileInput[0].files.length > 1) {
        setTimeout(() => {
          $documentField.find(".file-path").val(`${$documentFileInput[0].files.length} files selected`);
        }, 0);
      }
    });

    $clearButton.on("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      $documentFileInput[0].value = "";
      $documentField.find(".file-path").val("");
      $clearButton.addClass("hide");
      $unsavedHint.addClass("hide");
      updateRequiredIcon($documentFileInput);
    });

    $documentField.find(".js-re-upload").on("click", (event) => {
      event.preventDefault();

      $inputFieldContainer.removeClass("hide");
      $documentUploadedContainer.addClass("hide");

      updateRequiredIcon($documentFileInput);
    });

    $documentField.find(".js-mark-as-reviewed").on("click", (event) => {
      event.preventDefault();

      let $eventTarget = $(event.target);
      const $button = $eventTarget.is("button") ? $eventTarget : $eventTarget.closest("button");

      const studentId = $button.data("studentId");
      const documentName = $button.data("documentName");

      const request = $.ajax({
        type: "PUT",
        url: `/admin/students/${studentId}/mark_document_as_reviewed/`,
        data: JSON.stringify({
          document_name: documentName,
        })
      });

      request.done((response) => {
        const $documentMeta = $button.siblings(".js-document-meta");
        $documentMeta.text(response.reviewed_on);
        $button.addClass("hide");

        showSuccessToast();
      });

      request.fail(() => showErrorToast());
    });

    $documentField.on("click", ".js-edit-expiry", (event) => {
      event.preventDefault();

      const $row = $(event.currentTarget).closest(".document-uploaded-file");
      const $scope = $row.length ? $row : $documentField;

      $scope.find(".js-expiry").addClass("hide");
      $scope.find(".js-edit-expiry").addClass("hide");
      $scope.find(".js-expiry-field .js-date-picker").prop("disabled", false);
      $scope.find(".js-expiry-field").removeClass("hide");
    });

    $documentField.find(".js-delete-attachment").on("click", (event) => {
      const attachmentId = $(event.currentTarget).data("attachment-id");
      const $form = $(".js-edit-student-profile-form");
      $form.append(`<input type="hidden" name="student[delete_attachment_ids][]" value="${attachmentId}">`);

      const $uploadedFile = $(event.currentTarget).closest(".document-uploaded-file");
      if ($uploadedFile.length) {
        // Many-attachment row
        $uploadedFile.hide();
      } else {
        // Single-attachment: hide the uploaded container and show the upload input
        $documentUploadedContainer.addClass("hide");
        $inputFieldContainer.removeClass("hide");
      }

      $documentField.find(".js-delete-pending-notice").removeClass("hide");
    });
  });
};

const initEnrollmentReviewPage = () => {
  const initDocumentExpiryForms = () => {
    const $form  = $(".js-document-expiry-form");

    addAJAXResponseHandlers($form, {
      onSuccess: () => {
        $form.find(".js-date-picker").each((index, input) => {
          const $input = $(input);

          if (!$input.val()) {
            return;
          }

          const expiryDateParts = new Date(`${$input.val()}T00:00:00`)
            .toString().split(" ").slice(1, 4);

          const $row = $input.closest("tr");
          const $expiryDate = $row.find(".js-expiry");

          $expiryDate.find("span").text(
            `${expiryDateParts[0]} ${expiryDateParts[1]}, ${expiryDateParts[2]}`
          );
          $expiryDate.removeClass("hide");

          $row.find(".js-date-field").addClass("transparent");
        });

        const hideSubmitButton = $form.find(".js-date-field").toArray().every(
          (dateField) => $(dateField).hasClass("transparent")
        );

        if (hideSubmitButton) {
          $form.find(":submit").addClass("hide");
        }
      },
    });
  };

  const initMarkDocumentAsReviewed = () => {
    $(".js-mark-as-reviewed").on("click", (event) => {
      event.preventDefault();

      let $eventTarget = $(event.target);
      const $button = $eventTarget.is("button") ? $eventTarget : $eventTarget.closest("button");

      const studentId = $button.data("studentId");
      const documentName = $button.data("documentName");

      const request = $.ajax({
        type: "PUT",
        url: `/admin/students/${studentId}/mark_document_as_reviewed/`,
        data: JSON.stringify({
          document_name: documentName,
        })
      });

      request.done((response) => {
        const $reviewedOn = $button.siblings(".js-reviewed-on");
        $reviewedOn.text(response.reviewed_on);
        $reviewedOn.removeClass("hide");
        $button.addClass("hide");

        showSuccessToast();
      });

      request.fail(() => showErrorToast());
    });
  };

  const initNotesAndRequestChangesModalForms = () => {
    const formTypes = ["request-changes", "add-note", "add-payment"];

    formTypes.forEach((type) => {
      const form = document.querySelector(`.js-${type}-form`);
      const $form = $(form);
      const modal = form.closest(`.js-${type}-modal`);
      const $contentInput = $form.find("textarea");
      const $numberInput = $form.find("[type=\"number\"]");
      const closeModalButton = modal.querySelector(".js-modal-close");
      const $paymentAmountInput = $form.find(".js-amount-field")
      const $paymentLast4Input = $form.find(".js-last-4-field")

      if (type === "add-payment") {
        const paymentLastDigitsContainer = modal.querySelector(".js-payment-digits");
        const paymentLastDigitsInput = paymentLastDigitsContainer.querySelector("input");
        const paymentMethodSelect = modal.querySelector(".js-payment-method select");
        const paymentPurchaseSelect = modal.querySelector(".js-payment-purchase select");
        const forRegistrationCheckbox = modal.querySelector(".js-for-registration-checkbox");

        paymentMethodSelect.addEventListener("change", () => {
          if (paymentMethodSelect.value == "cash" || paymentMethodSelect.value == "cheque" || paymentMethodSelect.value == "eCheque - SCO") {
            paymentLastDigitsContainer.classList.add("hide");
            paymentLastDigitsInput.required = false;
            paymentLastDigitsInput.value = "";
          } else {
            paymentLastDigitsContainer.classList.remove("hide");
            paymentLastDigitsInput.required = true;
          }
        });

        paymentPurchaseSelect.addEventListener("change", () => {
          if (paymentPurchaseSelect.value == "annual_registration_fee") {
            forRegistrationCheckbox.classList.add("hide");
          } else {
            forRegistrationCheckbox.classList.remove("hide");
          }
        });
      }

      closeModalButton.addEventListener("click", () => {
        $numberInput.val("");
        $contentInput.val("");
        $paymentAmountInput.val("");
        $paymentLast4Input.val("");
      });

      let successMessage = "Change requested"

      if (type === "add-payment") {
        successMessage = "Payment added";
      } else if (type === "add-note") {
        successMessage = "Note created";
      }

      const ajaxHandlerOptions = {
        successMessage,
        onSuccess: (response) => {
          updateEnrollmentStatusBadge(response.enrollment_status);

          const itemsContainer = document.querySelector(`.js-${type}-items`);
          const template = itemsContainer.querySelector(`.js-item-template`);
          const itemsContainerEmptyState = itemsContainer.querySelector(".js-empty-item");

          const newItem = template.cloneNode(true);
          newItem.classList.remove(`.js-item-template`);

          if (type === "add-payment") {
            newItem.querySelector(".js-amount").innerText = `$${response.amount}`;
            newItem.querySelector(".js-description").innerText = response.description || "";
            newItem.querySelector(".js-edit-link").href = response.edit_url;
            newItem.querySelector(".js-type").innerText = response.purchase;
            const schoolYearEl = newItem.querySelector(".js-school-year");
            if (schoolYearEl) {
              schoolYearEl.innerText = response.school_year || "";
            }
          } else {
            const itemContent = type === "request-changes" ? response.request : response.text;
            newItem.querySelector(".js-content").innerText = itemContent;
            newItem.querySelector(".js-created-by").innerText = response.created_by;
          }

          newItem.querySelector(".js-created-at").innerText = response.created_at;

          if (type === "add-payment") {
            let $paymentTypeHeader;

            if (response.annual_tuition_payment) {
              $paymentTypeHeader = $(".js-annual-registration-fees-header");
              $(".js-annual-fee-not-paid").addClass("hide");
              $(".js-annual-fee-paid").removeClass("hide");
              $(document).find(".js-tuition-reminder").addClass("hide");
            } else if (response.enrollment_fee_payment) {
              $paymentTypeHeader = $(".js-registration-fees-header");
            } else {
              $paymentTypeHeader = $(".js-other-fees-header");
            }

            // Insert the new payment item after the payment type header
            $paymentTypeHeader.removeClass("hide");
            $paymentTypeHeader.after(newItem);
          } else {
            itemsContainer.append(newItem);
          }

          if (type === "request-changes") {
            const $requestedChangesCount = $(".js-requested-changes-count");

            const currentRequestedChangesCount = parseInt($requestedChangesCount.children().first().text());
            $requestedChangesCount.children().first().text(currentRequestedChangesCount + 1);

            $requestedChangesCount.removeClass("hide");
          }

          newItem.classList.remove("hide");

          if (itemsContainerEmptyState) {
            itemsContainer.removeChild(itemsContainerEmptyState);
          }

          $numberInput.val("");
          $contentInput.val("");
          $paymentAmountInput.val("");
          $paymentLast4Input.val("");

          Materialize.Modal.getInstance(modal).close();
        },
      };

      addAJAXResponseHandlers(form, ajaxHandlerOptions);
    });
  };

  const intitMuteNotification = () => {
    const $form = $(".js-mute-notifications-form");

    $form.on("change", "input[type=\"checkbox\"]", () => {
      $.rails.fire($form.get(0), "submit");
    });

    addAJAXResponseHandlers($form);
  };

  const intitUpdateCreatedAt = () => {
    const $form = $(".js-enrollment-created-at-form");

    $form.on("change", "input.js-date-picker", () => {
      $.rails.fire($form.get(0), "submit");
    });

    addAJAXResponseHandlers($form);
  };

  intitUpdateCreatedAt();
  intitMuteNotification();
  initDocumentExpiryForms();
  initMarkDocumentAsReviewed();
  initNotesAndRequestChangesModalForms();
};

const initCourseImportPage = () => {
  document.querySelector("form").addEventListener("submit", () => {
    const loader = document.querySelector(".js-loader");

    document.querySelector(".js-import-settings").classList.add("hide");

    loader.classList.remove("hide");
    loader.classList.add("in");
  });
};

const initCourseSearchPage = () => {
  const managedStudentSelectElements = document.querySelectorAll(".js-managed-student-select");

  managedStudentSelectElements.forEach((managedStudentSelectElement) => {
    managedStudentSelectElement.addEventListener("change", (event) => {
      const studentId = event.target.value;
      $(event.target).closest("form").find(".js-course-action").addClass("hide")
      $(event.target).closest("form").find(`.js-course-action[data-student-id="${studentId}"]`).removeClass("hide")
    });
  });

  const modalElement = document.querySelector(".js-enrollment-feedback-modal");
  const modalLoaderElement = modalElement.querySelector(".js-loader");
  const modalMessageElement = modalElement.querySelector(".js-message");
  const $modalEnrolledMessage = $(modalMessageElement).find(".js-enrolled");
  const $modalWaitlistedMessage = $(modalMessageElement).find(".js-waitlisted");
  const $modalConflictMessage = $(modalMessageElement).find(".js-conflict");
  const modalErrorMessageElement = modalMessageElement.querySelector(".js-error");
  const modalStudentNameElement = modalMessageElement.querySelector(".js-student-name");
  const modalCloseElement = modalMessageElement.querySelector(".js-close");

  const modalInstance = Materialize.Modal.getInstance(modalElement);

  const formElements = document.querySelectorAll(".js-enrollment-form");

  formElements.forEach((formElement) => {
    formElement.addEventListener("submit", () => {
      modalLoaderElement.classList.remove("hide");
      modalMessageElement.classList.remove("in");

      $modalEnrolledMessage.addClass("hide");
      $modalWaitlistedMessage.addClass("hide");
      modalErrorMessageElement.classList.add("hide");
      $modalConflictMessage.addClass("hide");
      modalCloseElement.classList.add("hide");
    });

    // @TODO Add an error modal
    formElement.addEventListener("ajax:success", (event) => {
      const { course, enrollment, result, student, isAdminEditing } = event.detail[0];
      const $managedStudentSelect = $(formElement).find(".js-managed-student-select");
      const guardianIsRegistering = $managedStudentSelect.length >= 1;

      const $confirmEnrollmentModal = $(`#conflict-confirm-${course.id}`);
      if ($confirmEnrollmentModal.length) {
        Materialize.Modal.getInstance($confirmEnrollmentModal.get(0)).close();
      }

      modalInstance.open();

      if (result == "error" || result == "conflict") {
        $modalEnrolledMessage.addClass("hide");
        $modalWaitlistedMessage.addClass("hide");
        modalCloseElement.classList.remove("hide");

        if (result == "error") {
          modalErrorMessageElement.classList.remove("hide");
          $modalConflictMessage.addClass("hide");
        } else {
          if (guardianIsRegistering) {
            $modalConflictMessage.find(".js-student-name").text(`${student.full_name} is`);
          } else {
            $modalConflictMessage.find(".js-student-name").text("you are");
          }

          modalErrorMessageElement.classList.add("hide");
          $modalConflictMessage.removeClass("hide");
        }

        modalLoaderElement.classList.add("hide");
        modalMessageElement.classList.add("in");
      } else {
        const statusSelectElement = formElement.querySelector(".js-status-select");

        if (guardianIsRegistering) {
          $managedStudentSelect.val("");
          Materialize.FormSelect.getInstance($managedStudentSelect.get(0))._setValueToInput();

          const optionIndex = $managedStudentSelect.find(`[value="${student.id}"]`).index();
          $managedStudentSelect.find("option").eq(optionIndex).remove();
          $managedStudentSelect.siblings(".dropdown-content.select-dropdown")
            .find("li")
            .eq(optionIndex)
            .remove();

          // All students have been registered/waitlisted
          if ($managedStudentSelect.find("option").length == 1) {
            $(formElement).empty().append("<p style=\"margin-left: auto;\">No students available to register</p>");
          }
        }

        if (statusSelectElement) {
          statusSelectElement.closest(".select-wrapper").querySelector(".dropdown-trigger").disabled = true;
        }

        $(formElement).find("input[type=\"submit\"]").prop("disabled", true);

        modalErrorMessageElement.classList.add("hide");
        $modalConflictMessage.addClass("hide");
        modalCloseElement.classList.remove("hide");

        $(formElement).closest(".js-action-container").find(".js-available-spots").addClass("hide");

        if (student.guardian || isAdminEditing) {
          modalStudentNameElement.textContent = `${student.full_name} has`;
        } else {
          modalStudentNameElement.textContent = `You have`;
        }

        if (enrollment.status === "pending_review" || enrollment.status === "approved") {
          if (guardianIsRegistering) {
            $modalEnrolledMessage.find(".js-student-name").text(`${student.full_name} has`);
          } else {
            $modalEnrolledMessage.find(".js-student-name").text("You have");
          }

          $modalEnrolledMessage.removeClass("hide");
          $modalWaitlistedMessage.addClass("hide");
        } else {
          if (guardianIsRegistering) {
            $modalWaitlistedMessage.find(".js-student-name").text(`${student.full_name} has`);
          } else {
            $modalWaitlistedMessage.find(".js-student-name").text("You have");
          }

          $modalEnrolledMessage.addClass("hide");
          $modalWaitlistedMessage.removeClass("hide");
        }

        // Do not allow the student to register for the same course again
        $(`.js-course[data-course-code="${course.code}"]`).each((_, element) => {
          const $element = $(element);
          const otherCourseSectionNumber = $element.data("courseSectionNumber").toString();

          if (otherCourseSectionNumber !== course.section_number) {
            $element.find(".js-enrollment-status").text(enrollment.status == "waitlisted" ? "Waitlisted" : "Registered");
            $element.find(".js-action-container").addClass("hide");
            $element.find(".js-already-registered-container").removeClass("hide");
          }
        });

        modalLoaderElement.classList.add("hide");
        modalMessageElement.classList.add("in");
      }
    });
  });

  const $muteEnrollmentNotifications = $(".js-mute-enrollment-notifications");
  $muteEnrollmentNotifications.on("change", (event) => {
    const checked = $muteEnrollmentNotifications.is(":checked")

    formElements.forEach((formElement) => {
      $(formElement).find(".js-mute-notifications").val(checked ? 1 : 0);
    });
  });
};

const initStudentRegistrationsPage = () => {
  if (!document.querySelector("body.students--enrollments")) {
    return;
  }

  const $emptyState = $(".js-empty");
  const $studentSelect = $(".js-student");
  const modal = document.querySelector(".js-drop-course-result");
  const modalErrorMessgeElement = modal.querySelector(".js-error");
  const modalSuccessMessageElement = modal.querySelector(".js-success");
  const modalCourseNameElement = modal.querySelector(".js-course-name");
  const modalLoaderElement = modal.querySelector(".js-loader");
  const modalMessageElement = modal.querySelector(".js-message");

  const modalInstance = Materialize.Modal.getInstance(modal);

  document.querySelectorAll(".js-drop-course").forEach((dropCourseLinkElement) => {
    dropCourseLinkElement.addEventListener("click", () => {
      modalLoaderElement.classList.remove("hide");
      modalMessageElement.classList.remove("in");
      modalMessageElement.classList.add("hide");
      modalInstance.open();
    });

    $(dropCourseLinkElement).closest("form").on("ajax:success", (event) => {
      const response = event.detail[0];
      const failed = !!response.error;

      if (failed) {
        modalErrorMessgeElement.classList.remove("hide");
        modalSuccessMessageElement.classList.add("hide");
        modalCourseNameElement.classList.add("hide");
      } else {
        modalErrorMessgeElement.classList.add("hide");
        modalSuccessMessageElement.classList.remove("hide");

        const courseName = response.course.name;
        $(modalCourseNameElement).text(courseName);
        modalCourseNameElement.classList.remove("hide");

        $(dropCourseLinkElement).closest(".js-enrollment").remove();

        if ($(".js-enrollment").length === 0) {
          $emptyState.removeClass("hide");
          $studentSelect.closest(".select-field").addClass("hide");
        } else {
          const studentId = response.student_id;
          const enrollmentsForStudent = $(`.js-enrollment[data-student-id="${studentId}"]`)

          if (!enrollmentsForStudent.length) {
            const optionIndex = $studentSelect.find(`[value="${studentId}"]`).index();
            $studentSelect.find("option").eq(optionIndex).remove();
            $studentSelect.siblings(".dropdown-content.select-dropdown")
              .find("li")
              .eq(optionIndex)
              .remove();
          }

          // Only one student is still in the list
          if ($studentSelect.find("option").length == 2) {
            $studentSelect.closest(".select-field").addClass("hide");
          }
        }
      }

      modalLoaderElement.classList.add("hide");
      modalMessageElement.classList.remove("hide");
      modalMessageElement.classList.add("in");
    });
  });

  $studentSelect.on("change", (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "All") {
      $(".js-enrollment").removeClass("hide")
    } else {
      $(".js-enrollment").addClass("hide");
      $(`.js-enrollment[data-student-id="${selectedValue}"]`).removeClass("hide");
    }

    const $currentEnrollmentContainer = $(".js-current-enrollments");
    const $visibleCurrentEnrollments = $(".js-current-enrollments").find(".js-enrollment:not(.hide)");
    const $currentEnrollmentsNoFilteredResults = $currentEnrollmentContainer.find(".js-no-filtered-results");
    const $pastEnrollmentContainer = $(".js-past-enrollments");
    const $visiblePastEnrollments = $pastEnrollmentContainer.find(".js-enrollment:not(.hide)");
    const $pastEnrollmentsNoFilteredResults = $pastEnrollmentContainer.find(".js-no-filtered-results");

    if ($emptyState.hasClass("hide")) {
      if ($visibleCurrentEnrollments.length === 0) {
        $currentEnrollmentsNoFilteredResults.removeClass("hide");
      } else {
        $currentEnrollmentsNoFilteredResults.addClass("hide");
      }
    }

    if ($visiblePastEnrollments.length === 0) {
      $pastEnrollmentsNoFilteredResults.removeClass("hide");
    } else {
      $pastEnrollmentsNoFilteredResults.addClass("hide");
    }
  });
};

const initEmailTemplatesPage = () => {
  document.querySelectorAll("form").forEach((form) => addAJAXResponseHandlers(form));
};

const initBulkActions = () => {
  if (isComponentInitialized("bulkActions")) {
    return;
  }

  if (!document.querySelector(".js-bulk-action")) {
    return;
  }

  componentInitialized("bulkActions");

  const getElements = () => {
    const container = document.querySelector(".js-bulk-action");
    const $successModal = $(document).find("#bulk-action-success-modal");

    return ({
      container,
      $successModal,
      template: container.querySelector(".js-template"),
      emptyState: container.querySelector(".js-empty"),
      table: container.querySelector("tbody"),
      courseSelect: container.querySelector(".js-course-select"),
      statusSelect: container.querySelector(".js-status-select"),
      muteNotificationsCheckbox: container.querySelector(".js-mute-notifications"),
      executeButton: container.querySelector(".js-execute"),
      searchResultsContainer: document.querySelector(".js-search-results-container"),
      successModalInstance: Materialize.Modal.getInstance($successModal[0]),
    });
  };

  // Disable execute button if no students are selected
  $(document).on("click", ".js-add-student", (event) => {
    const { table, executeButton } = getElements();
    if (event.target.value && table.querySelectorAll(".js-student-row").length) {
      executeButton.disabled = false;
    } else {
      executeButton.disabled = true;
    }
  });

  // Disable execute button if no course is selected
  $(document).on("change", ".js-bulk-action .js-course-select", (event) => {
    const { executeButton, emptyState } = getElements();
    if (event.target.value && !$(emptyState).is(":visible")) {
      executeButton.disabled = false;
    } else {
      executeButton.disabled = true;
    }
  });

  // Execute bulk action
  $(document).on("click", ".js-bulk-action .js-execute", () => {
    const {
      container,
      table,
      courseSelect,
      statusSelect,
      muteNotificationsCheckbox,
      emptyState,
      executeButton,
      searchResultsContainer,
      $successModal,
      successModalInstance,
    } = getElements();

    executeButton.disabled = true;

    const studentRows = table.querySelectorAll(".js-student-row");

    let action;
    let actionUrl;

    switch(container.dataset.action) {
      case "register":
        action = "bulk_register";
        actionUrl = "/enrollments/bulk";
        break;
      case "transfer":
        action = "bulk_transfer";
        actionUrl = "/transfers/bulk";
        break;
      default:
        action = null;
        actionUrl = null;
        break;
    }

    if (!action || !actionUrl) {
      showErrorToast();
      return;
    }

    const payload = {
      [action]: {
        course_id: courseSelect.value,
        status: statusSelect.value,
        mute_notifications: muteNotificationsCheckbox.checked,
      },
    };

    const studentIds = Array.from(studentRows).map((studentRow) => studentRow.dataset.studentId);
    if (studentIds.length) {
      payload[action].student_ids = studentIds;
    }

    const enrollmentIds = Array.from(studentRows)
      .map((studentRow) => studentRow.dataset.enrollmentId)
      .filter(function(enrollmentId) {
        return enrollmentId && enrollmentId !== "undefined";
      });
    if (enrollmentIds.length) {
      payload[action].enrollment_ids = enrollmentIds;
    }

    const authToken = document.querySelector("meta[name=\"csrf-token\"]").content
    const request = new XMLHttpRequest();

    request.addEventListener("load", () => {
      const response = JSON.parse(request.responseText);

      if (response.error) {
        showErrorToast();
        executeButton.disabled = false;
        return;
      }

      Materialize.Collapsible.getInstance(container).close();
      emptyState.classList.remove("hide");

      // Remove all students
      studentRows.forEach((studentRow) => {
        studentRow.remove();

        const searchResultsStudentRow =
            searchResultsContainer.querySelector(`[data-student-id="${studentRow.dataset.studentId}"]`);

        // The student may not be in the search results anymore so only remove the row if it is
        if (typeof container.dataset.removeOnSave !== "undefined" && searchResultsStudentRow) {
          searchResultsStudentRow.remove();
        }
      });

      // Reset the inputs
      courseSelect.value = "";
      statusSelect.value = "pending_review";
      muteNotificationsCheckbox.checked = false;
      Materialize.FormSelect.getInstance(courseSelect)._setValueToInput();
      Materialize.FormSelect.getInstance(statusSelect)._setValueToInput();

      // Reset the add buttons
      document.querySelectorAll(".js-add-student").forEach((registerAddButton) => {
        registerAddButton.disabled = false;
      });

      const searchResultsEmpty = searchResultsContainer.querySelectorAll("tr:not(.hide)").length > 0;
      if (searchResultsEmpty) {
        const searchResultsEmptyState = searchResultsContainer.querySelector(".js-empty");
        if (searchResultsEmptyState) {
          searchResultsEmptyState.classList.remove("hide");
        }
      }

      const $resultsTable = $successModal.find(".js-results");
      if ($resultsTable.length) {
        $resultsTable.empty();

        response.messages.success.forEach((message) => {
          const $row = $("<tr>");

          const $type = $("<td>");
          $type.text("Success");

          const $message = $("<td>");
          $message.text(message);

          $row.append($type);
          $row.append($message);

          $resultsTable.append($row);
        });

        response.messages.error.forEach((message) => {
          const $row = $("<tr>");

          const $type = $("<td>");
          $type.text("Error");

          const $message = $("<td>");
          $message.text(message);

          $row.append($type);
          $row.append($message);

          $resultsTable.append($row);
        });
      }

      successModalInstance.open();
      executeButton.disabled = false;
    });

    request.addEventListener("error", () => {
      Rollbar.error("Bulk action failed", { actionUrl, payload });
      executeButton.disabled = false;
    });

    request.open("POST", actionUrl, true);
    request.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
    request.setRequestHeader('X-CSRF-Token', authToken);
    request.send(JSON.stringify(payload));
  });

  // Redmove student from bulk action list
  $(document).on("click", ".js-bulk-action", (event) => {
    const { table, emptyState, executeButton, searchResultsContainer } = getElements();

    const registerRemoveButton = event.target.closest(".js-remove");
    if (!registerRemoveButton) {
      return;
    }

    const studentRow = registerRemoveButton.closest(".js-student-row");

    // The student may not be in the search results anymore so only enable the add button if it is
    const searchResultsStudentRow = searchResultsContainer.querySelector(`[data-student-id="${studentRow.dataset.studentId}"]`);
    if (searchResultsStudentRow) {
      $(searchResultsStudentRow).find(".js-add-student").prop("disabled", false)
    }

    studentRow.remove();

    const showEmptyState = table.querySelectorAll(".js-student-row").length === 0;
    if (showEmptyState) {
      emptyState.classList.remove("hide");
      executeButton.disabled = true;
    }
  });

  // Add student to bulk action list
  $(document).on("click", ".js-search-results-container", (event) => {
    const { table, emptyState, executeButton, template, courseSelect } = getElements();

    const registerAddButton = event.target.closest(".js-add-student");
    if (!registerAddButton) {
      return;
    }

    const row = registerAddButton.closest("tr");

    let shouldAdd = true;

    table.querySelectorAll("tr").forEach((studentrow) => {
      if (studentrow.dataset.studentId === row.dataset.studentId) {
        shouldAdd = false;
      }
    });

    if (shouldAdd) {
      const newRow = template.cloneNode(true);
      newRow.dataset.studentId = row.dataset.studentId;
      newRow.dataset.enrollmentId = row.dataset.enrollmentId;
      newRow.querySelector(".js-name").textContent = row.dataset.studentName;
      if (row.dataset.studentEmail) {
        newRow.querySelector(".js-email").textContent = row.dataset.studentEmail;
      }
      if (row.dataset.studentPen) {
        newRow.querySelector(".js-pen").textContent = row.dataset.studentPen;
      }

      table.append(newRow);

      emptyState.classList.add("hide");

      newRow.classList.remove("hide");
      newRow.classList.remove("js-template");
      newRow.classList.add("js-student-row");


      if (courseSelect.value) {
        executeButton.disabled = false;
      }
    }

    registerAddButton.disabled = true;
  });

  // Show icon to add student to bulk action when bulk action is opened
  $(document).on("collapsible:open", ".js-bulk-action", () => {
    document.querySelectorAll(".js-add-student").forEach((registerAddButton) => {
      registerAddButton.classList.remove("hide");
    });
  });

  // Hide icon to add student to bulk action when bulk action is closed
  $(document).on("collapsible:close", ".js-bulk-action", () => {
    document.querySelectorAll(".js-add-student").forEach((registerAddButton) => {
      registerAddButton.classList.add("hide");
    });
  });
};

const reInitBulkActions = () => {
  $(".js-bulk-action-container").each((index, container) => {
    const $container = $(container);
    if ($container.hasClass("active")) {
      const existingEmails = $container.find(".js-student-row .js-email").map((index, email) => {
        return email.textContent;
      }).toArray();

      $(".js-search-results-container tr").each((index, row) => {
        const $row = $(row);
        const $rowAddStudent = $row.find(".js-add-student")
        const email = $row.data("studentEmail");

        $rowAddStudent.removeClass("hide");
        $rowAddStudent.prop("disabled", existingEmails.includes(email));
      });
    }
  });
};

const initCourseEditPage = () => {
  const $modalClose = $(".js-close-modal");
  $modalClose.on("click", (event) => event.preventDefault());

  const $emailRegisteredStudentsForm = $(".js-email-registered-students-form");
  if ($emailRegisteredStudentsForm.length) {
    addAJAXResponseHandlers($emailRegisteredStudentsForm, {
      onSuccess: (_response, event) => {
        $(":input, .trix-content", $emailRegisteredStudentsForm)
          .not(":button, :submit, :reset, :hidden")
          .val("")
      },
    });
  }
};

const initAdminEditStudentProfilePage = () => {
  const closeModal = (event) => {
    const $modal = $(event.currentTarget).closest(".js-non-dismissible-modal");
    if ($modal.length) {
      Materialize.Modal.getInstance($modal.get(0)).close();
    }
  }

  addAJAXResponseHandlers(".js-delete-payment", {
    noSuccessToast: true,
    onSuccess: (_response, event) => {
      closeModal(event);
      showSuccessToast("Payment successfully deleted", true);
      window.location.reload();
    },
  })

  addAJAXResponseHandlers(".js-add-payment-form", {
    noSuccessToast: true,
    onSuccess: (_response, event) => {
      closeModal(event);
      showSuccessToast("Payment successfully created", true);
      window.location.reload();
    },
  });
};

const initDocuments = () => {
  const $addDocumentform = $(".js-add-documents-form");

  addAJAXResponseHandlers($addDocumentform, { noSuccessToast: true });
};

const initSchoolYearToggle = () => {
  $(document).on("change", ".js-payment-purchase select", (event) => {
    const $paymentPurchaseSelect = $(event.target);
    const $paymentForm = $paymentPurchaseSelect.closest("form");
    const $schoolYearField = $paymentForm.find(".js-school-year-field");

    if ($schoolYearField.length === 0) {
      return;
    }

    if ($paymentPurchaseSelect.val() === "annual_registration_fee") {
      $schoolYearField.removeClass("hide");
    } else {
      $schoolYearField.addClass("hide");
    }
  });
};


window.REGISTER_BC = {
  initializeComponents: () => {
    initSidenav();
    initModals();
    initNonDismissableModals();
    initDropdowns();
    initDatePickers();
    initTimePickers();
    initSelectBoxes();
    initTabs();
    initTooltips();
    initCollapsibles();
    initNotifications();
    initAutoFormatPhoneNumber();
    initBulkActions();
    initDocumentInputFields();
    initStudentSignupForm();
    initRejectModal();
    initStatusUpdateSelect();
    fixBrokeninputElements();
    initExportToCsvLinks();
    initCitizenshipMetadataSelects();
    initSchoolYearToggle();
  },
  initializedComponents: {},
  reInitBulkActions,
  initEnrollmentReviewPage,
  initEditStudentProfilePage,
  initCourseEditPage,
  initCourseImportPage,
  initCourseSearchPage,
  initDocuments,
  initStudentRegistrationsPage,
  initEmailTemplatesPage,
  initAdminEditStudentProfilePage,
  showSuccessToast,
  showErrorToast,
};

disableTrixEditorFileAttachment();

document.addEventListener("DOMContentLoaded", () => {
  window.REGISTER_BC.initializeComponents();

  if (document.querySelector("body.enrollments--edit.is-admin-section")) {
    window.REGISTER_BC.initEnrollmentReviewPage();
  }

  if (document.querySelector("body.students--edit.is-admin-section")) {
    window.REGISTER_BC.initDocuments();
    window.REGISTER_BC.initEditStudentProfilePage();
    window.REGISTER_BC.initAdminEditStudentProfilePage();
  }

  if (document.querySelector("body.courses--edit.is-admin-section")) {
    window.REGISTER_BC.initCourseEditPage();
  }

  if (document.querySelector("body.courses--import.is-admin-section")) {
    window.REGISTER_BC.initCourseImportPage();
  }

  if (document.querySelector("body.settings--email_templates.is-admin-section")) {
    window.REGISTER_BC.initEmailTemplatesPage();
  }

  if (document.querySelector("body.students--course_search")) {
    window.REGISTER_BC.initCourseSearchPage();
  }

  if (document.querySelector("body.students--enrollments")) {
    window.REGISTER_BC.initStudentRegistrationsPage();
  }

  showOnPageLoadToast();
});
